import { affiliateConstants } from "../constants/affiliateConstants";

const initialState = {
  sending: false,
  affiliateResponse: {},
  custSalesList: {},
  affiliateList: {},
  error: {},
  deletedaffiliate: {},
  affiliateDetail: {},
  updatedAffiliate: {},
  affiliateDashboard: {},
  affDashboardByuser: {}
};

export default function affiliateReducer(state = initialState, action) {
  switch (action.type) {
    case affiliateConstants.ADD_AFFILIATE_REQUEST:
      return {
        sending: true
      };
    case affiliateConstants.ADD_AFFILIATE_SUCCESS:
      return {
        ...state,
        affiliateResponse: action.data
      };
    case affiliateConstants.ADD_AFFILIATE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case affiliateConstants.GET_CUST_SALES_LIST_REQUEST:
      return {
        sending: true
      };
    case affiliateConstants.GET_CUST_SALES_LIST_SUCCESS:
      return {
        ...state,
        custSalesList: action.data
      };
    case affiliateConstants.GET_CUST_SALES_LIST_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case affiliateConstants.GET_AFFILIATE_REQUEST:
      return {
        sending: true
      };
    case affiliateConstants.GET_AFFILIATE_SUCCESS:
      return {
        ...state,
        affiliateList: action.data
      };
    case affiliateConstants.GET_AFFILIATE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case affiliateConstants.DELETE_AFFILIATE_REQUEST:
      return {
        sending: true
      };
    case affiliateConstants.DELETE_AFFILIATE_SUCCESS:
      return {
        ...state,
        deletedaffiliate: action.data
      };
    case affiliateConstants.DELETE_AFFILIATE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case affiliateConstants.GET_AFFILIATEDETAIL_REQUEST:
      return {
        sending: true
      };
    case affiliateConstants.GET_AFFILIATEDETAIL_SUCCESS:
      return {
        ...state,
        affiliateDetail: action.data.data
      };
    case affiliateConstants.GET_AFFILIATEDETAIL_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case affiliateConstants.UPDATE_AFFILIATE_REQUEST:
      return {
        sending: true
      };
    case affiliateConstants.UPDATE_AFFILIATE_SUCCESS:
      return {
        ...state,
        updatedAffiliate: action.data
      };
    case affiliateConstants.UPDATE_AFFILIATE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case affiliateConstants.GET_AFFILIATE_DASHBOARD_REQUEST:
      return {
        sending: true
      };
    case affiliateConstants.GET_AFFILIATE_DASHBOARD_SUCCESS:
      return {
        ...state,
        affiliateDashboard: action.data
      };
    case affiliateConstants.GET_AFFILIATE_DASHBOARD_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case affiliateConstants.GET_AFFILIATE_DASHBOARD_BYUSER_REQUEST:
      return {
        sending: true
      };
    case affiliateConstants.GET_AFFILIATE_DASHBOARD_BYUSER_SUCCESS:
      return {
        ...state,
        affDashboardByuser: action.data
      };
    case affiliateConstants.GET_AFFILIATE_DASHBOARD_BYUSER_FAILURE:
      return {
        ...state,
        error: action.error
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/affiliateReducer.js